import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = {
  data: [],
  user: null,
  error: null,
  loading: false,
  editLoading: true,
  permissionChange: null,
};

//  Define slice and it's reducer functions.
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    resetState(state) {
      state.data = [];
      state.error = null;
      state.loading = true;
      state.user = null;
      state.permissionChange = { loading: false, error: null, data: null };
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    setPermissionChange(state, action) {
      state.permissionChange = {
        loading: action.payload.loading,
        error: action.payload.error,
        data: action.payload.data,
      };
    },
  },
});

export const userAction = userSlice.actions;

export default userSlice;
